import React from "react"
import "components/style.scss"
import PhoneArea from "components/PhonePreview/PhoneArea"

const PopupPreview = (
  {
    title = "Title",
    content = "description text here",
    buttonText = "learn more",
    previewData
  }) => {

  let image = ""
  if (previewData.image_url && typeof previewData.image_url === "object" && previewData.image_url[0]) {
    image = previewData.image_url[0].preview
  }
  else if (typeof previewData.image_url === "string") {
    image = previewData.image_url
  }


  return (
    <PhoneArea>
      <div style={{ backgroundImage: `url(${image})` }} className={"popup-preview"}>
        {/*close button container*/}
        <div className={"d-flex justify-content-end"}><i className='bx bx-x bx-sm'></i></div>

        {/*content container*/}
        <div className={"popup-content d-flex align-items-center flex-column"}>
          <div className={"title"}>{previewData.title}</div>
          <div className={"description"}>{previewData.text}</div>
        </div>

        {/*button container*/}
        <div className={"popup-btn"}>
          {previewData.button_text}
        </div>
        <div className={"advertisementContainer"}>
          {previewData.is_advertisement
            ? <div className={"advertisement"}>ADVERTISEMENT</div>
            : null
          }
        </div>
      </div>

    </PhoneArea>
  )
}

export default PopupPreview
